module.exports = ".clappr-flash-playback[data-flash-playback]{display:block;position:absolute;top:0;left:0;height:100%;width:100%;pointer-events:none}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/sass-loader!./public/flash.scss
// module id = 4
// module chunks = 0